import React, { useContext, Fragment, useEffect } from "react";
import { JornadaTrabalhoFaltaContext } from "../JornadaTrabalhoFaltaContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarJornadaTrabalhoFalta = () => {
  const { values, setValues, resetScreen } = useContext(JornadaTrabalhoFaltaContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={JornadaTrabalhoFaltaContext}>
        <div className="col-12 col-md-3">
          <label>Nome do Consultor</label>
          <input
            className="form-control"
            type="text"
            name="usuarioNome"
            value={values.searchData.usuarioNome}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={JornadaTrabalhoFaltaContext} />
    </Fragment>
  );
};

export default PesquisarJornadaTrabalhoFalta;
